module.exports = __webpack_public_path__ + "static/media/Article 3.7c04218e.svg";